import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import {PLButton} from './PLFields';
import Paper from '@mui/material/Paper';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import {KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight} from './svgIcons';

function not(a, b, keySelector) {
    return a.filter(
        (v) => b.findIndex((x) => keySelector(v) === keySelector(x)) === -1
    );
}

function intersection(a, b, keySelector) {
    return a.filter(
        (v) => b.findIndex((x) => keySelector(v) === keySelector(x)) !== -1
    );
}

export default function TransferList({
    sourceData,
    value,
    onChange = ([]) => {},
    render = (value) => value,
    keySelector = (value) => value,
}) {
    const [checked, setChecked] = React.useState([]);
    //   const [left, setLeft] = React.useState([0, 1, 2, 3]);
    //   const [right, setRight] = React.useState([4, 5, 6, 7]);

    const leftChecked = intersection(checked, sourceData, keySelector);
    const rightChecked = intersection(checked, value, keySelector);

    const [left, setLeftDisplay] = useState([]);

    const setLeft = () => {
        const d = not(sourceData, value, keySelector);

        setLeftDisplay(d);
    };

    useEffect(() => {
        setLeft();
    }, [sourceData, value]);

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const handleAllRight = () => {
        onChange(value.concat(left));
        setLeft();
    };

    const handleCheckedRight = () => {
        onChange(value.concat(leftChecked));
        setLeft();
        setChecked(not(checked, leftChecked, keySelector));
    };

    const handleCheckedLeft = () => {
        setLeft();
        onChange(not(value, rightChecked, keySelector));
        setChecked(not(checked, rightChecked, keySelector));
    };

    const handleAllLeft = () => {
        setLeft();
        onChange([]);
    };

    const customList = (items) => (
        <Paper
            sx={{
                width: '20rem',
                height: '23rem',
                overflow: 'auto',
            }}>
            <List dense component="div" role="list">
                {items.map((value) => {
                    const labelId = `transfer-list-item-${value}-label`;

                    return (
                        <ListItem
                            key={value}
                            role="listitem"
                            button
                            onClick={handleToggle(value)}>
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked.indexOf(value) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{'aria-labelledby': labelId}}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id={labelId}
                                primary={render(value)}
                            />
                        </ListItem>
                    );
                })}
                <ListItem />
            </List>
        </Paper>
    );

    return (
        <Grid container justifyContent="center" alignItems="center">
            <Grid item>{customList(left)}</Grid>
            <Grid item>
                <Grid container direction="column" alignItems="center">
                    <Grid item>
                        <PLButton
                            variant="outlined"
                            size="small"
                            onClick={handleAllRight}
                            disabled={left.length === 0}
                            aria-label="move all right">
                            <KeyboardDoubleArrowRight></KeyboardDoubleArrowRight>
                        </PLButton>
                    </Grid>
                    <Grid item>
                        <PLButton
                            variant="outlined"
                            size="small"
                            onClick={handleCheckedRight}
                            disabled={leftChecked.length === 0}
                            aria-label="move selected right">
                            <KeyboardArrowRightRoundedIcon />
                        </PLButton>
                    </Grid>
                    <Grid item>
                        <PLButton
                            variant="outlined"
                            size="small"
                            onClick={handleCheckedLeft}
                            disabled={rightChecked.length === 0}
                            aria-label="move selected left">
                            <KeyboardArrowLeftRoundedIcon />
                        </PLButton>
                    </Grid>
                    <Grid item>
                        <PLButton
                            variant="outlined"
                            size="small"
                            onClick={handleAllLeft}
                            disabled={value.length === 0}
                            aria-label="move all left">
                            <KeyboardDoubleArrowLeft />
                        </PLButton>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>{customList(value)}</Grid>
        </Grid>
    );
}
